<template>
    <main-content with_go_back_bar>
        <div class="pb-4 px-4">
            <settlement-detail v-if="is_detail_ready"
                               :settlement_withdraw_type="settlement_withdraw_type"
                               :settlement_data="settlement_data"
                               :total_amount="total_amount"
                               :error_message="error_message"
                               :ref_code="ref_code"
                               :status="status"
                               :payment_date="payment_date"
                               :approximate_payment_date="approximate_payment_date"
                               :bank="bank"
                               :destination_bank="destination_bank"
                               :is_reversal="is_reversal"
                               :collection_id="collection_id"
                               :detected_by="detected_by"
                               :reversed_by="reversed_by"
            >
            </settlement-detail>
        </div>
        <form v-if="has_code"
              class="pb-4 px-4"
              id="verify_form"
        >
            <div class="row">
                <div class="col-12 col-md-6 my-2">
                    <label for="code" v-text="$t('label.verify_code')"></label>
                    <input class="form-control"
                           dir="ltr"
                           id="code"
                           name="code"
                           v-model="code"
                    >
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="new_status" v-text="$t('label.new_status')"></label>
                    <select class="form-control"
                            id="new_status"
                            name="new_status"
                            v-model="new_status"
                    >
                        <option v-text="walletTransactionStatusStr.get(walletTransactionStatus.SUCCESS)"
                                :value="walletTransactionStatus.SUCCESS">
                        </option>
                        <option v-text="walletTransactionStatusStr.get(walletTransactionStatus.FAILED)"
                                :value="walletTransactionStatus.FAILED">
                        </option>
                        <option v-text="walletTransactionStatusStr.get(walletTransactionStatus.FAILED_NOT_SENT)"
                                :value="walletTransactionStatus.FAILED_NOT_SENT">
                        </option>
                        <option v-text="walletTransactionStatusStr.get(walletTransactionStatus.CANCELED)"
                                :value="walletTransactionStatus.CANCELED">
                        </option>
                        <option v-text="walletTransactionStatusStr.get(walletTransactionStatus.PENDING)"
                                :value="walletTransactionStatus.PENDING">
                        </option>
                        <option v-text="walletTransactionStatusStr.get(walletTransactionStatus.UNKNOWN_YET)"
                                :value="walletTransactionStatus.UNKNOWN_YET">
                        </option>
                    </select>
                </div>
                <div class="col-12 col-md-6 my-2" v-show="new_status === walletTransactionStatus.SUCCESS">
                    <label for="new_ref_code" v-text="$t('label.ref_code')"></label>
                    <input class="form-control"
                           dir="ltr"
                           id="new_ref_code"
                           name="new_ref_code"
                           v-model="new_ref_code"
                    >
                </div>
                <div class="col-12 col-md-6 my-2" v-show="new_status === walletTransactionStatus.SUCCESS">
                    <label for="source_account_number" v-text="$t('label.source_account_number')"></label>
                    <select class="form-control"
                           id="source_account_number"
                           name="source_account_number"
                           v-model="source_account_number"
                    >
                        <option v-for="(bank_account, index) in all_bank_accounts"
                                :key="index"
                                v-text="bank_account.number + ' (' + bank_account.bank_fa_name + ')'"
                                :value="bank_account.number">
                        </option>
                    </select>
                </div>
            </div>
        </form>
        <form v-if="
        status === walletTransactionStatus.PENDING
        || status === walletTransactionStatus.UNKNOWN_YET
        || status === walletTransactionStatus.SUCCESS"
              id="pay-form"
              class="shadow-sm p-4"
        >
            <div class="row" v-if="$can('change-status', 'wallet')">
                <div class="col-12 my-2">
                    <template v-if="has_code">
                        <button type="button"
                                @click="change_status()"
                                v-text="$t('btn.change_status')"
                                class="btn btn-danger mx-2"
                        >
                        </button>
                    </template>
                    <button v-else
                            type="button"
                            @click="getVerifyCode()"
                            v-text="$t('label.get_verify_code_for_determine_status')"
                            class="btn btn-success mx-2"
                    >
                    </button>
                </div>
            </div>
        </form>
    </main-content>
</template>

<script>
    import MainContent from "@/components/main-content";
    import {authService, walletService} from "@/common/api.service";
    import SettlementDetail from '../components/settlement-detail';
    import {walletTransactionStatus, walletTransactionStatusStr} from "@/constants/walletTransactionStatus";
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";

    export default {
        components: {
            MainContent,
            SettlementDetail,
        },
        data() {
            return {
                walletTransactionStatus,
                walletTransactionStatusStr,
                settlement_data: {},
                settlement_withdraw_type: null,
                total_amount: 0,
                error_message: '',
                ref_code: '',
                status: null,
                is_detail_ready: false,
                has_code: false,
                code: '',
                new_status: null,
                new_ref_code: '',
                source_account_number: null,
                all_bank_accounts: [],
                payment_date: '',
                approximate_payment_date: '',
                bank: '',
                destination_bank: '',
                is_reversal: false,
                collection_id : null,
            };
        },
        computed: {
            slug() {
                return this.$route.params.slug;
            },

            fetchStarshop() {
                return this.slug === 'starshop';
            }

        },
        mounted() {

            let getSettlementDetails;
            let getWalletBankAccount;

            if (this.fetchStarshop) {
                getSettlementDetails = walletService.getAdminStarShopSettlementDetailAyande;
                getWalletBankAccount = walletService.getStarShopAllWalletBankAccountNumbers;
            } else {
                 getSettlementDetails = walletService.getAdminSettlementDetailAyande;
                 getWalletBankAccount = walletService.getAllWalletBankAccountNumbers;
            }
            console.log('ebi')

            getSettlementDetails(this.$route.params.hashid).then(res => {
                this.settlement_withdraw_type = res.data.data.settlement_withdraw_type;
                this.settlement_data = res.data.data.settlement_data;
                this.total_amount = res.data.data.total_amount;
                this.status = res.data.data.status;
                this.error_message = res.data.data.error_message;
                this.ref_code = res.data.data.ref_code;
                this.is_reversal = (res.data.data.charge_rev_id !== '');
                this.bank = res.data.data.bank_id;
                this.destination_bank = res.data.data.destination_bank_id;
                this.payment_date = res.data.data.payment_date;
                this.detected_by = res.data.data.detected_by;
                this.reversed_by = res.data.data.reversed_by;
                this.approximate_payment_date = res.data.data.approximate_payment_date;
                this.is_detail_ready = true;
                this.collection_id = res.data.data.collection_id;
            });

            getWalletBankAccount().then(res => {
                this.all_bank_accounts = res.data;
            });
        },
        methods: {
            getVerifyCode() {
                let phone = this.$store.state.user.current_user.phone;

                let verify = {
                    phone,
                };

                if(this.$route.params.slug === "starshop") {
                    authService.sendStarshopVerifyWallet(verify).then(res => {
                        this.has_code = true;
                    });
                } else {
                    authService.sendVerifyForDetermine(verify).then(res => {
                        this.has_code = true;
                    });
                }
            },
            change_status() {
                let form = $('#verify_form');

                if (! confirm(i18n.t('message.are_you_sure_to_change_this_transaction_status'))) {
                    return;
                }

                let params = {
                    code: this.code,
                    status: this.new_status,
                    ref_code: this.new_ref_code,
                    source_account_number: this.source_account_number,
                };

                if(this.$route.params.slug === "starshop") {
                    walletService.determineAyandeStarshop(params, this.$route.params.hashid).then(() => {
                        this.$router.push('/wallets/admin');
                    }).catch(({response}) => {
                        this.showMsg(form, 'danger', response.data.message);
                    });
                } else {
                    walletService.determineAyande(params, this.$route.params.hashid).then(() => {
                        this.$router.push('/wallets/admin');
                    }).catch(({response}) => {
                        this.showMsg(form, 'danger', response.data.message);
                    });
                }
            },
        },
    }
</script>
